var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-config-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.downloadLoading,
              expression: "downloadLoading",
            },
          ],
          staticClass: "list-container",
        },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "会员卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "系统审核状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.systemStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "systemStatus", $$v)
                        },
                        expression: "searchForm.systemStatus",
                      },
                    },
                    _vm._l(_vm.systemStatuslist, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "审核状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateSystemStatus(6)
                        },
                      },
                    },
                    [_vm._v("季度复审")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateSystemStatus(0)
                        },
                      },
                    },
                    [_vm._v("审核中复审")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                stripe: "",
                border: "",
                "element-loading-text": "数据加载中...",
                "element-loading-spinner": "el-icon-loading",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "申请人", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "会员卡号", prop: "cardNo", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "手机号", prop: "mobile", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "等级",
                  prop: "grade",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.grade == 1
                          ? _c("div", [_vm._v("普卡")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.grade == 2
                          ? _c("div", [_vm._v("银卡")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.grade == 3
                          ? _c("div", [_vm._v("金卡")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.grade == 4
                          ? _c("div", [_vm._v("黑金卡")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.grade == 5
                          ? _c("div", [_vm._v("钻石卡")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "成长值",
                  prop: "gradeContent",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "申请时间",
                  prop: "createTime",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "系统审核状态",
                  prop: "systemStatus",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.systemStatus == 0
                          ? _c("div", [_vm._v("审核中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.systemStatus == 1
                          ? _c("div", [_vm._v("审核通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.systemStatus == 2
                          ? _c("div", [_vm._v("审核未通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.systemStatus == 4
                          ? _c("div", [_vm._v("复审通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.systemStatus == 3
                          ? _c("div", [_vm._v("复审不通过")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "审核状态", prop: "status", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 0
                          ? _c("div", [_vm._v("审核中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c("div", [_vm._v("审核通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c("div", [_vm._v("审核未通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c("div", [_vm._v("申诉中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 4
                          ? _c("div", [_vm._v("申诉不通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 5
                          ? _c("div", [_vm._v("申诉通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 6
                          ? _c("div", [_vm._v("已领取")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 7
                          ? _c("div", [_vm._v("已降级")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 8
                          ? _c("div", [_vm._v("审核终止")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "380" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 0
                          ? _c(
                              "div",
                              { staticStyle: { display: "inline-block" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("审核通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 2)
                                      },
                                    },
                                  },
                                  [_vm._v("审核不通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 8)
                                      },
                                    },
                                  },
                                  [_vm._v("终止")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3
                          ? _c(
                              "div",
                              { staticStyle: { display: "inline-block" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 5)
                                      },
                                    },
                                  },
                                  [_vm._v("申诉通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 4)
                                      },
                                    },
                                  },
                                  [_vm._v("申诉不通过")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 6
                          ? _c(
                              "div",
                              { staticStyle: { display: "inline-block" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reviewDialog(scope.row, 7)
                                      },
                                    },
                                  },
                                  [_vm._v("降级")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.toDEtail(scope.row)
                              },
                            },
                          },
                          [_vm._v("审核进度")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.showAddDialog,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              attrs: {
                model: _vm.addForm,
                "label-width": "140px",
                rules: _vm.addFormRules,
              },
            },
            [
              _c("el-form-item", { attrs: { label: "用户信息" } }, [
                _c("div", [_vm._v(_vm._s(_vm.addForm.userName) + " ")]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "会员卡号" } }, [
                _c("div", [_vm._v(_vm._s(_vm.addForm.cardNo) + " ")]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "成长值" } }, [
                _c("div", [_vm._v(_vm._s(_vm.addForm.gradeContent) + " ")]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "审核原因/备注", prop: "remark2" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.addForm.remark2,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "remark2", $$v)
                      },
                      expression: "addForm.remark2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showAddDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitAddForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }